document.addEventListener('DOMContentLoaded', () => {
    // Addition items
    $('.new-pdp-testimonials__list--mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        dotsClass: 'new-pdp-testimonials__dots',
        adaptiveHeight: true,
        centerMode: true,
        infinite: false,
        variableWidth: true
    });
});